let modeModalCall;
let linkLocations = document?.getElementById("link-locations");
let linkStore = document?.getElementById("link-store");
let standarButton = document?.getElementById("standard");
let pickStoreButton = document?.getElementById("pick-store");

let method = {
  get selected() {
    return this._selected;
  },
  set selected(value) {
    this._selected = value;
    if (value === "DeliveryEs") {
      standarButton.checked = true;
      pickStoreButton.checked = false;
      return _setCurrentShippingMethodForm({ store_type: "DeliveryEs" });
    }
    if (value === "Tienda") {
      standarButton.checked = false;
      pickStoreButton.checked = true;
      return _setCurrentShippingMethodForm({ store_type: "Tienda" });
    }

    standarButton.checked = false;
    pickStoreButton.checked = false;
    _setCurrentShippingMethodForm(null);
  },
};

const dispatchEventIsOpenModalStore = (open) => {
  modeModalCall = "store";
  window.dispatchEvent(
    new CustomEvent("is-open-modal-store", { detail: { open, mode: "view" } })
  );
};

const dispatchEventIsOpenModalLocation = (open, firstOpen) => {
  modeModalCall = "location";
  window.dispatchEvent(
    new CustomEvent("is-open-modal-location", { detail: { open, firstOpen } })
  );
};

const setStockButton = () => {
  if ($("#text-estimated").hasClass("text-danger")) {
    document.querySelectorAll(".add-cart-button").forEach((button) => {
      button.classList.add("disabled");
      button.classList.remove("initial-state");
      button.innerText = "Sin stock";
    });
  } else {
    document.querySelectorAll(".add-cart-button").forEach((button) => {
      button.classList.remove("disabled");
      button.classList.remove("initial-state");
      button.innerText = "Agregar al carrito";
    });
  }
};

const setStockButtonStore = () => {
  if ($("#text-estimated-store").hasClass("text-danger")) {
    document.querySelectorAll(".add-cart-button").forEach((button) => {
      button.classList.add("disabled");
      button.classList.remove("initial-state");
      button.innerText = "Sin stock";
    });
  } else {
    document.querySelectorAll(".add-cart-button").forEach((button) => {
      button.classList.remove("disabled");
      button.classList.remove("initial-state");
      button.innerText = "Agregar al carrito";
    });
  }
};

const modalShippingSelected = () => {
  standarButton.addEventListener("click", (e) => {
    const locationSelected = JSON.parse(localStorage.getItem("locations"));

    if (!locationSelected) {
      dispatchEventIsOpenModalLocation(true);
      return (method.selected = null);
    }
    if (!e.target.checked) {
      document.querySelectorAll(".add-cart-button").forEach((button) => {
        button.classList.remove("disabled");
        button.classList.remove("initial-state");
        button.innerText = "Agregar al carrito";
      });
      return (method.selected = null);
    }

    setStockButton();
    return (method.selected = "DeliveryEs");
  });

  pickStoreButton.addEventListener("click", (e) => {
    const storeSelected = JSON.parse(localStorage.getItem("stores"));

    if (!storeSelected) {
      dispatchEventIsOpenModalStore(true);
      return (method.selected = null);
    }
    if (!e.target.checked) {
      return (method.selected = null);
    }

    setStockButtonStore();
    return (method.selected = "Tienda");
  });

  linkLocations.addEventListener("click", (e) => {
    e.preventDefault();
    dispatchEventIsOpenModalLocation(true);
    setStockButton();
  });

  linkStore.addEventListener("click", (e) => {
    e.preventDefault();
    dispatchEventIsOpenModalStore(true);
    setStockButtonStore();
  });
};

const getStoreSelected = () => {
  const element = document.getElementsByName("store-picker");
  let storeSelected;
  for (const ele of element) {
    if (ele.checked) {
      storeSelected = ele.value;
      break;
    }
  }
  return storeSelected;
};

const _setCurrentShippingMethodForm = (val) =>
  $("#current_shipping_method").val(JSON.stringify(val));

const setLocationEstimatedData = async (data) => {
  const locationEstimated = document.getElementById("text-estimated");
  const tooltip = document.getElementById("subtitle-tooltip");
  const address = document.getElementById("subtitle");
  const regionSelected = JSON.parse(localStorage.getItem("locations"));

  if (!regionSelected) return;
  const textEstimated = `Estimado para ${regionSelected.city.name}, ${regionSelected.state.name} `;
  if (data.stock[0].quantity_available > 0) {
    locationEstimated.classList.remove("text-danger");
    tooltip.setAttribute("data-tooltip", textEstimated);
    locationEstimated.innerHTML = `Recibelo en tu dirección el ${convertDate(
      data.result.date_transfer
    )}`;
    address.innerHTML = textEstimated.slice(0, 35) + "...";
    return;
  }

  address.innerHTML = textEstimated.slice(0, 35) + "...";
  locationEstimated.innerHTML = `No disponible para tu ubicación`;
  locationEstimated.classList.add("text-danger");
  tooltip.setAttribute("data-tooltip", textEstimated);
};

const setStoreEstimatedData = (data) => {
  const isStock = data.stock[0].quantity_available > 0;
  const storeEstimated = document.getElementById("text-estimated-store");
  const tooltip = document.getElementById("subtitle-tooltip-store");
  const address = document.getElementById("subtitle-store");
  const textEstimated = `Estimado para ${data?.delivery?.name}`;
  const storeSelected = JSON.parse(localStorage.getItem("stores"));
  address.innerHTML = textEstimated.slice(0, 35) + "...";

  if (!storeSelected) return;
  if (isStock) {
    storeEstimated.classList.remove("text-danger");

    tooltip.setAttribute("data-tooltip", textEstimated);
    storeEstimated.innerHTML = `Listo para recoger el ${convertDate(
      data?.result?.date_transfer
    )}`;
    return;
  }

  storeEstimated.innerHTML = `No disponible para retiro en esta tienda`;
  storeEstimated.classList.add("text-danger");
  tooltip.setAttribute("data-tooltip", textEstimated);
};

const handleMessageError = (response) => {
  if (
    !response ||
    response?.response?.status >= 400 ||
    response?.data[0]?.error
  ) {
    showErrorCompute(true);
    // showShippingSection(false);
    return true;
  }

  if (isErrorCompute()) showErrorCompute(false);

  return false;
};

const onSubmitLocation = () => {
  const btnContinue = document?.querySelector(".submit-location");

  btnContinue?.addEventListener("click", async (event) => {
    event.preventDefault();
    const currentVariant = JSON.parse(
      document.getElementsByName("current_variant")[0].value
    );

    const regionSelected = document
      .getElementById("select-btn-region-location")
      .getAttribute("data-info");
    const comunaSelected = document
      .getElementById("select-btn-comune-location")
      .getAttribute("data-info");
    const shopifyCode = document
      .getElementById("select-btn-region-location")
      .getAttribute("data-code-shopify");
    const regionData = JSON.parse(regionSelected);
    const comunaData = JSON.parse(comunaSelected);
    localStorage.setItem("selectedMethod", "DeliveryEs");

    let _element = document.getElementById("message-location");

    if (!regionData || !comunaData) {
      const _message = "Debes seleccionar una región y comuna";
      _element.innerHTML = _message;
      _element.classList.remove("hidden");
      return;
    }
    if (!_element.classList.contains("hidden"))
      _element.classList.add("hidden");

    const lines = currentVariant.map((variant) => {
      return {
        sku: variant.sku,
        quantity: 1,
        amount_total: variant.price,
      };
    });
    const shipping_address = {
      country: "CL",
      state: regionData.code,
      city: comunaData.code,
    };

    const _shipping_address_local = {
      country: "CL",
      state: {
        code: regionData.code,
        name: regionData.name,
        id: regionData.id,
        shopify_code: shopifyCode,
      },
      city: {
        code: comunaData.code,
        name: comunaData.name,
        zipcode: comunaData.zipcode ?? "00000",
      },
    };

    const data = {
      shipping_address,
      lines,
      deliveries: [
        {
          method_code: "DeliveryEs",
          warehouse_code: "",
        },
      ],
    };

    setITemLocalStorage("locations", _shipping_address_local);
    method.selected = "DeliveryEs";

    const response = await compute(data);
    handleMessageError(response);
    setLocationEstimatedData(response.data[0]);
    closeModalLocation();
    setStockButton();
  });
};

const onSubmitLocationAddress = async () => {
  const currentVariant = JSON.parse(
    document.getElementsByName("current_variant")[0].value
  );

  const regionSelected = document
    .getElementById("select-btn-region-location")
    .getAttribute("data-info");
  const comunaSelected = document
    .getElementById("select-btn-comune-location")
    .getAttribute("data-info");
  const shopifyCode = document
    .getElementById("select-btn-region-location")
    .getAttribute("data-code-shopify");
  const regionData = JSON.parse(regionSelected);
  const comunaData = JSON.parse(comunaSelected);

  const lines = currentVariant.map((variant) => {
    return {
      sku: variant.sku,
      quantity: 1,
      amount_total: variant.price,
    };
  });
  const shipping_address = {
    country: "CL",
    state: regionData.code,
    city: comunaData.code,
  };

  const _shipping_address_local = {
    country: "CL",
    state: {
      code: regionData.code,
      name: regionData.name,
      id: regionData.id,
      shopify_code: shopifyCode,
    },
    city: {
      code: comunaData.code,
      name: comunaData.name,
      zipcode: comunaData.zipcode ?? "00000",
    },
    type_modal: "location",
  };

  const data = {
    shipping_address,
    lines,
    deliveries: [
      {
        method_code: "DeliveryEs",
        warehouse_code: "",
      },
    ],
  };

  setITemLocalStorage("locations", _shipping_address_local);
  method.selected = "DeliveryEs";

  const response = await compute(data);
  handleMessageError(response);
  setLocationEstimatedData(response.data[0]);
  setStockButton();
};

const onSubmitStore = () => {
  const btnContinue = document.querySelector(".submit-store");

  btnContinue.addEventListener("click", async (event) => {
    event.preventDefault();
    const storeSelected = JSON.parse(getStoreSelected());
    const currentVariant = JSON.parse(
      document.getElementsByName("current_variant")[0].value
    );
    const lines = currentVariant.map((variant) => {
      return { sku: variant.sku, quantity: 1, amount_total: variant.price };
    });

    localStorage.setItem("selectedMethod", "pick-store");

    const data = {
      cart_id: 1692828328,
      subtotal: 839.005501,
      lines,
      deliveries: [
        {
          method_code: "Tienda",
          warehouse_code: storeSelected.code,
        },
      ],
    };

    _setCurrentShippingMethodForm({
      store_type: "Tienda",
      store: storeSelected,
    });
    setITemLocalStorage("stores", storeSelected);
    method.selected = "Tienda";

    const response = await compute(data);
    handleMessageError(response);
    setStoreEstimatedData(response.data[0]);
    setStockButtonStore();
  });
};

const stockAvailable = async (lines) => {
  const body = {
    lines,
    deliveries: [{ method_code: "Tienda" }, { method_code: "DeliveryEs" }],
  };

  try {
    const response = await axios.post(
      `${baseUrlOMS}/api/v1/stock/available/`,
      body,
      fetchConfig
    );
    const stockResponse = response?.data;
    return stockResponse;
  } catch (error) {
    handleMessageError(error);
  }
};

const getDataStorage = async () => {
  if (locationStorage)
    getCityByRegionOms(locationStorage.state.code, "location", true);
  if (storeStorage) getCityByRegionOms(storeStorage.state.id, "store", true);
};

const handleVariantAsyncSingleton = function () {
  let instance;

  function createInstance() {
    const newInstance = {
      lastVariant: null,
      dispatch: async function (variant, callBack) {
        if (!variant?.available) return { stopProcess: true, response: null };

        // this.lastVariant = variant
        const response = await callBack();
        const stopProcess = this.lastVariant?.sku !== variant?.sku;

        return { stopProcess, response };
      },
    };

    instance = newInstance;
    return newInstance;
  }

  return instance ?? createInstance();
};

const handleStockAvailableSingle = handleVariantAsyncSingleton();
const handleComputeUserLoggedSingle = handleVariantAsyncSingleton();

const handleChangeSkuOMS = async (variant) => {
  if (variant?.available) {
    handleStockAvailableSingle.lastVariant = deepClone(variant);
    handleComputeUserLoggedSingle.lastVariant = deepClone(variant);
    showErrorCompute(false);
    showShippingLinks(true);

    showAddToCartBtn(false);
    await dispatchStockAvailable(deepClone(variant));
    // await dispatchComputeUserLogged(deepClone(variant));
    showAddToCartBtn(true);
  } else {
    handleStockAvailableSingle.lastVariant = deepClone(variant);
    handleComputeUserLoggedSingle.lastVariant = deepClone(variant);
    showErrorCompute(false);
    showShippingSection(false);
    showShippingLinks(false);
  }
};

const dispatchStockAvailable = async (variant) => {
  if (variant) {
    // showShippingSection(false);
    showLoader(true);
    const callBack = async () => await stockAvailable([{ sku: variant.sku }]);
    const { stopProcess, response } = await handleStockAvailableSingle.dispatch(
      variant,
      callBack
    );
    showLoader(false);

    if (stopProcess) return;

    // showShippingSection(true);
    stockAvailableOms(response);
  }
};

const dispatchComputeUserLogged = async (currentVariant) => {
  let locationUser = JSON.parse(localStorage.getItem("locations")) ?? null;
  let storeStorage = JSON.parse(localStorage.getItem("stores")) ?? null;
  const selectShippingStandar = document.getElementsByClassName(
    "standard-shipping disabled"
  );
  const selectPickStore = document.getElementsByClassName(
    "pick-up-in-store disabled"
  );
  if (
    (locationUser && !selectShippingStandar.length > 0) ||
    (storeStorage && !selectPickStore.length > 0)
  ) {
    const lines = [
      {
        sku: currentVariant?.sku,
        quantity: 1,
        amount_total: currentVariant?.price,
      },
    ];
    const shipping_address = {
      country: locationUser?.country,
      state: locationUser?.state?.code,
      city: locationUser?.city?.code,
    };
    const deliveries = [
      {
        method_code: "DeliveryEs",
        warehouse_code: "",
      },
    ];

    if (storeStorage) {
      deliveries.push({
        method_code: "Tienda",
        warehouse_code: storeStorage?.code,
      });
    }
    const data = { shipping_address, deliveries, lines };

    const callBack = async () => await compute(data);
    const { stopProcess, response } =
      await handleComputeUserLoggedSingle.dispatch(currentVariant, callBack);

    if (stopProcess) return;
    if (handleMessageError(response)) return;

    response.data.forEach((item) => {
      if (item.delivery.code === "DeliveryEs") setLocationEstimatedData(item);
      if (item.delivery.code === "Tienda") setStoreEstimatedData(item);
    });

    if (method.selected === "DeliveryEs") setStockButton();
    if (method.selected === "Tienda") setStockButtonStore();
  }

  // showShippingSection(true);
};

const stockAvailableOms = (res) => {
  if (!Boolean(res) || Boolean(res.error)) return;

  const methodStock = res.methods;
  const selectShippingStandar =
    document.getElementsByClassName("standard-shipping");
  const selectPickStore = document.getElementsByClassName("pick-up-in-store");
  const linkShippingLocation = document.getElementById("link-locations");
  const linkShippingStore = document.getElementById("link-store");
  const messageShipping = document.getElementById("message-shipping-standard");
  const messagePickStore = document.getElementById("message-shipping-store");
  const hasStockStore = methodStock.some(
    (method) => method.method_code === "Tienda" && method.result
  );
  const hasStockShipping = methodStock.some(
    (method) => method.method_code === "DeliveryEs" && method.result
  );

  if (!hasStockStore) {
    linkShippingStore.classList.add("disabled");
    selectPickStore[0].classList.add("disabled");
    messagePickStore.classList.add("text-danger");
    document.getElementById("subtitle-store").innerHTML =
      "Comprueba disponibilidad eligiendo una tienda";
    document.getElementById("text-estimated-store").innerHTML = "";
    messagePickStore.innerHTML = "No disponible para retiro en tienda";
    document.getElementById("pick-store").checked = false;
  } else {
    linkShippingStore.classList.remove("disabled");
    selectPickStore[0].classList.remove("disabled");
    messagePickStore.classList.remove("text-danger");
    messagePickStore.innerHTML = "";
  }

  if (!hasStockShipping) {
    linkShippingLocation.classList.add("disabled");
    selectShippingStandar[0].classList.add("disabled");
    messageShipping.classList.add("text-danger");
    document.getElementById("subtitle").innerHTML =
      "Comprueba tu ubicación eligiendo una dirección de envío";
    document.getElementById("text-estimated").innerHTML = "";
    messageShipping.innerHTML = "No disponible para envío a domicilio";
    document.getElementById("standard").checked = false;
  } else {
    linkShippingLocation.classList.remove("disabled");
    selectShippingStandar[0].classList.remove("disabled");
    messageShipping.classList.remove("text-danger");
    messageShipping.innerHTML = "";
  }

  if (!hasStockStore && !hasStockShipping) {
    document.querySelectorAll(".add-cart-button").forEach((button) => {
      button.classList.add("disabled");
      button.classList.remove("initial-state");
      button.innerText = "Sin stock";
    });
  } else {
    document.querySelectorAll(".add-cart-button").forEach((button) => {
      button.classList.remove("disabled");
      button.classList.remove("initial-state");
      button.innerText = "Agregar al carrito";
    });
  }
};

const isErrorCompute = () => !$("#error-compute").hasClass("d-none");
const showAddToCartBtn = (show) => showGeneric(".add-cart-button", show);
const showErrorCompute = (show) => showGeneric("#error-compute", show);
const showShippingLinks = (show) => showGeneric("#shipping-link", show);
const showLoader = (show) => showGeneric(".shipping-section-loader", show);
// const showShippingSection = (show) => showGeneric("#shipping-section", show);
const showGeneric = (selector, show) => {
  if (!show) return $(selector).addClass("d-none");

  $(selector).removeClass("d-none");
};
const deepClone = (object) => JSON.parse(JSON.stringify(object));

getDataStorage();
modalShippingSelected();
onSubmitLocation();
onSubmitStore();
